import React, { FC } from 'react';
import { NotificationBanner } from 'src/components/widgets/notificationBanner';
import { Link } from 'src/components/widgets/buttons';
import { T } from 'src/shared/helpers';

// Matches getVectorizeServiceConfig().learnMoreUrl (serviceCreditsConfigs.tsx).
const VECTORIZER_GUIDE_URL = 'https://zakeke.zendesk.com/hc/en-us/articles/22673500547996-Vectorizer';

interface DiscoveryVectorizeBannerProps {
    /** Opens the shared plan-upgrade dialog (useUpgradeDialogs), which owns the route to Subscription. */
    onUpgrade: () => void;
}

/**
 * Discovery-mode banner for the AI Vectorizer printing method, shown when the seller's plan cannot use it at
 * all (no `additionalFeatures.vectorization`, or a Shopify development store in production). The pill is
 * deliberately NOT hidden in that case: discovery exists to show merchants what they don't have yet, so a
 * feature their plan lacks is exactly what it should surface — with an honest way to get it.
 *
 * Credit states have no banner. Every account carries a free credit pack and from there usage is billed, so
 * there is nothing to activate; the warning that using the tool spends credits belongs where the spending
 * happens — the customizer's own credit-confirmation dialog on upload (useAICreditConfirmation('ai-vectorize')),
 * the same convention the AI Creative Tools follow.
 */
const DiscoveryVectorizeBanner: FC<DiscoveryVectorizeBannerProps> = ({ onUpgrade }) => (
    <NotificationBanner
        type='WARNING'
        variant='extended'
        content={
            <>
                <strong>{T._("Your plan doesn't include the AI Vectorizer", 'Admin')}</strong>
                {'\n'}
                {T._(
                    'It automatically turns uploaded images into clean vector artwork. Upgrade your plan to try it on this product and enable it for your customers.',
                    'Admin'
                )}{' '}
                <Link href={VECTORIZER_GUIDE_URL} target='_blank'>
                    {T._('Learn more', 'Admin')}
                </Link>
            </>
        }
        buttons={[{ label: T._('Upgrade plan', 'Admin'), onClick: onUpgrade }]}
    />
);

export default DiscoveryVectorizeBanner;
